<template>
  <button
    class="wt-highlight-preset wt-button hollow-dark"
    @click="selectItem($event, preset)"
  >
    <img
      v-if="preset.icon"
      class="-icon"
      :src="mixinSrc(preset.icon)"
      :alt="preset.code"
    />
    <div v-else class="-colour">
      <colour-icon :colour="preset.color" />
    </div>
    <div v-if="!preset.icon && !preset.color" class="-name">
      {{ preset.name || preset.code }}
    </div>
  </button>
</template>

<script>
import ColourIcon from './FieldText.colourIcon.vue';

export default {
  components: {
    ColourIcon,
  },
  props: {
    preset: { type: Object, required: true },
  },

  methods: {
    selectItem(e, preset) {
      this.$emit('applyPreset', preset);
    },
  },
};
</script>
